//#region src/currency.ts
var Currency = /* @__PURE__ */ function(Currency) {
	Currency["USD"] = "USD";
	Currency["CAD"] = "CAD";
	Currency["EUR"] = "EUR";
	Currency["GBP"] = "GBP";
	return Currency;
}(Currency || {});
//#endregion
export { Currency };

//# sourceMappingURL=currency.js.map